import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=0f89b65a&scoped=true"
var script = {}
import style0 from "./Index.vue?vue&type=style&index=0&id=0f89b65a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f89b65a",
  null
  
)

export default component.exports